<template>
  <div>
    <!-- 搜索区 -->
    <!-- <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <add-btn v-hasPermi="['cont:newContract:add']" @add="handleAddContract()" /> -->
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
      因权限问题，部分数据不方便显示
    </van-notice-bar>
    <van-search v-model="queryParams.contractName" placeholder="请输入合同名称搜索" @search="queryContractList" />
    <!-- 合同列表区 start -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['cont:newContract:list']" @load="handleContract" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <list-item @todetail="toContractDetails" :listData="list" />
      <!-- <van-cell v-for="(item,index) in list" :key="index" @click="toContractDetails(item)">
        <div class="flex-c-center" v-if="item">
         <div>
            <div class="custName-wrap">
              <div class="custName">
                <van-icon name="bookmark" color="green" />{{ item.custName }}
                <span>
                  <van-tag round>{{ formatHandel('contractStatus',item.contractStatus) }}</van-tag>
                </span>
              </div>
            </div>
            <div style="color: #1989fa">
              【{{item.businessTypeName}}】
            </div>
            <div>
              <div>
                <van-tag color="#ccc" style="margin-right: 5px" plain type="primary" v-if="item.templateType">合同模板：{{ formatHandel('templateType',item.templateType) }}</van-tag>
                <van-tag color="#ccc" style="margin-right: 5px" plain type="primary" v-if="item.payType">垫款方式：{{ formatHandel('payType',item.payType) }}</van-tag>
              </div>
              <div>
                <van-tag color="#ccc" style="margin-right: 5px" plain type="primary" v-if="item.frameType">框架类型：{{ formatHandel('frameType',item.frameType) }}</van-tag>
                <van-tag color="#ccc" style="margin-right: 5px" plain type="primary" v-if="item.contractMoney">合同总金额：{{ item.contractMoney }}(元)</van-tag>
              </div>
            </div>
          </div>
          <van-icon color="#c1c1c1" name="arrow" size="16" class="arrow-color"  @click="toContractDetails(item)" />

        </div>
      </van-cell> -->
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>
<script>
import newContract from '@/api/cont/newContract' // listContract
import { getDicts } from '@/api/system/dict/data'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import ListItem from '@/views/cont/components/contract/ListContractItem.vue'
import { NoticeBar } from 'vant'
export default {
  components: {
    EmptyComponent,
    TotalComponent,
    ListItem,
    [NoticeBar.name]: NoticeBar
  },
  data() {
    return {
      isEmpty: false,
      loading: false,
      finished: false,
      showFilterPop: false,
      list: [],
      total: 0,
      searchValue: '',
      options: {
        templateTypeOptions: [],
        frameTypeOptions: [],
        payTypeOptions: [],
        contractStatusOptions: []
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractName: '',
        // contractStatus: 0,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  async created() {
    if (this.$route.query.queryParams) {
      this.queryParams = { ...this.queryParams, ...JSON.parse(this.$route.query.queryParams) }
    }
    // 合同模板
    await getDicts('template_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    await this.handleContract()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '合同统计列表'
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.resetQuery()
      this.queryParams.contractName = this.searchValue = data
      this.queryContractList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryContractList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    queryContractList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleContract()
    },
    toContractDetails(item) {
      this.$router.push({
        path: '/cont/approve/detail',
        query: {
          id: item.contractId,
          active: '100'
          // verifyStatus: item.verifyStatus,
          // status: 1
        }
      })
    },
    // 获取合同数据
    async handleContract() {
      this.loading = true
      const res = await newContract.listContractQuery(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(res.rows)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
        this.showFilterPop = false
      }
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: '',
        contractStatus: 0,
        payMode: null,
        hkStatus: null,
        verifyStatus: 0,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  }
}
</script>
<style lang="less" scoped>
.editClue /deep/.van-dialog__content {
  height: 80%;
}
.van-list{
  padding-top: 0;
}
</style>
